const INACTIVE_LESSON_STATUSES = new Set(['cancelled', 'director_removed'])

export function isActiveAdminLesson(status: string | null | undefined): boolean {
  return !status || !INACTIVE_LESSON_STATUSES.has(status)
}

export function isCancelApiLiveLesson(status: string | null | undefined): boolean {
  return status !== 'cancelled'
}

export function countActiveAdminLessons(lessons: { status?: string | null }[] | undefined): number {
  if (!lessons?.length) return 0
  return lessons.filter(l => isActiveAdminLesson(l.status)).length
}

export function countCancelApiLiveLessons(lessons: { status?: string | null }[] | undefined): number {
  if (!lessons?.length) return 0
  return lessons.filter(l => isCancelApiLiveLesson(l.status)).length
}
